import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';

// https://www.algolia.com/doc/api-reference/widgets/refinement-list/react-hooks/#widget-param-sortby
// facetOrdering doesn't seem to work with hooks
const SearchFiltersRefinementList = ( props ) => {
	const { attribute, label } = props;

	const { items, refine } = useRefinementList( {
		attribute,
		sortBy: [ 'facetOrdering', 'name:asc' ],
	} );

	// if null, there is no space at the top. does it need to be hidden instead?
	if ( items.length === 0 ) {
		return null;
	}

	return (
		<div className={`${ items.length === 0 ? 'tw-hidden' : '' }`}>
			<div className="tw-font-bold tw-mb-2">{label}</div>
			<ul className="tw-pl-0 tw-list-none">
				{items.map( ( item ) => {
					return (
						<li key={item.label}>
							<label
								className="gtm-search-filter tw-cursor-pointer tw-flex"
								data-insights-filters={`${ attribute }:${ item.value }`}
							>
								<input className="tw-mr-2 tw-text-base" type="checkbox" checked={item.isRefined} onChange={() => refine( item.value )} />
								{item.label}
							</label>
						</li>
					);
				} )}
			</ul>
		</div>

	);
};

export default SearchFiltersRefinementList;
